/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { func, object } from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import {
    makeStyles, useMediaQuery, Tooltip,
} from '@material-ui/core';

import { useUIDSeed } from 'react-uid';
import ResponsiveImage from '../../GraphqlComponents/GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import ResponsiveImageOrSvg from './ResponsiveImageOrSvg';

const useStyles = makeStyles(() => ({
    listGroupItem: {
        padding: '10px',
        cursor: 'pointer',
        '&:active': {
            backgroundColor: 'inherit',
            color: 'inherit',
            borderColor: 'rgba(0,0,0,.1)',
        },
        border: '1px solid rgba(0,0,0,.125)',
        backgroundColor: '#fff',
        display: 'block',
        position: 'relative',
        alignItems: 'flex-start',
        marginBottom: '-1px',

    },
    dialog: {
        position: 'absolute',
        backgroundColor: '#fff',
        top: '20px',
        right: 0,
        width: '100%',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0,0,0,.12)',
        zIndex: 100,
    },
    mediaDialog: {
        position: 'absolute',
        backgroundColor: '#fff',
        top: '50px',
        right: 0,
        width: '100%',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0,0,0,.12)',
        zIndex: 100,
    },
    dialogHeader: {
        padding: '0.5rem 1rem',
        paddingRight: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #dee2e6',
        borderTopLeftRadius: '.3rem',
        borderTopRightRadius: '.3rem',
    },
    dialogTitle: {
        margin: 0,
        lineHeight: 1.5,
        fontSize: '1.25rem',
        fontWeight: 'bold',
    },
    dialogBody: {
        height: '420px',
        overflow: 'auto',
        position: 'relative',
        padding: '1rem',
    },
    listPicker: {

    },
    my2: {

    },
    listGroup: {
        display: 'flex',
        flexDirection: 'column',
        '& > :first-child': {
            borderTopLeftRadius: '.25rem',
            borderTopRightRadius: '.25rem',
        },
    },

    listItem: {
        display: 'flex',
        alignItems: 'center',
    },
    listItem2: {

    },
    listItemName: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        paddingLeft: '10px',
    },
    itemImg: {
        width: '45px',
        height: '45px',
        marginRight: '10px',
        borderRadius: '8px',
    },
    listItemTitle: {
        color: '#212529',
        fontSize: '16px',
        paddingLeft: '10px',
    },
    listItemSubtitle: {
        fontSize: '0.9rem',
        lineHeight: '1.7em',
        color: '#999',
    },
    checkIcon: {
        display: 'none',
    },
    close: {
        webkitAppearance: 'none',
        mozAppearance: 'none',
        appearance: 'none',
        fontSize: '1.3rem',
        fontWeight: '700',
        lineHeight: '1',
        color: '#000',
        textShadow: '0 1px 0 #fff',
        opacity: '.5',
        border: 'none',
        backgroundColor: 'transparent',
    },
    tooltipContainer: {
        textAlign: 'center',
        maxWidth: 350,
    },
    tooltipItemContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    tooltipItemTitle: {
        fontSize: '1.1rem',
        display: 'flex',
        alignItems: 'center',
        lineHeight: '1.1',
    },
    tooltipItemSubtitle: {
        fontSize: '0.85rem',
        color: '#f9f5f5',
    },
    tooltipImg: {
        maxWidth: 250,
    },
    bold: {
        fontWeight: 600,
    },
}));
const ChatDialog = ({
    closeDialog,
    onSubmitMessage,
    interactiveData,
    getSVGByKey,
    messageObj,
}) => {
    const {
        tooltipContainer,
        tooltipImg,
        tooltipItemContent,
        tooltipItemTitle,
        tooltipItemSubtitle,
        itemImg,
        listItem,
        listItemName,
        listItemSubtitle,
        listGroupItem,
        listGroupItemAction,
        bold,
        checkIcon,
        flexColum,
        alignItemsStart,
        listItemLink,
        mediaDialog,
        dialogHeader,
        dialog,
        dialogBody,
        dialogTitle,
        close,
        listPicker,
        my2,
        listGroup,
    } = useStyles();
    const matches = useMediaQuery('(min-width: 576px)');
    const { images, listPicker: { sections } } = interactiveData?.data;

    /**
     * returns the list picker option that matches the provided image identifier
     * @param {*} identifier
     */
    const getListPickerOption = (identifier) => sections?.[0]?.items?.find((listPickerOption) => listPickerOption?.identifier === identifier);

    const listOptions = images.map((listitem, index) => {
        const listPickerOption = getListPickerOption(listitem?.identifier);
        const dynamicIcon = listitem?.data?.includes('https') ? listitem?.data : getSVGByKey(listitem?.data?.split('/')[2] || listitem?.data)?.imageValue;

        const buildTooltip = (imgSrc, title, subtitle) => (
            <div className={tooltipContainer} data-testid="tooltip-container">
                <ResponsiveImage
                    path={imgSrc}
                    alt="preview"
                    className={tooltipImg}
                    params={{ desktop: 'quality=100', mobile: 'quality=100' }}
                />
                <span className={tooltipItemContent}>
                    <span className={tooltipItemTitle}>
                        {title}
                    </span>
                    <span className={tooltipItemSubtitle}>{subtitle}</span>
                </span>
            </div>
        );

        const preview = (imgSrc, title, subtitle) => (interactiveData.hover === 'Y' ? (
            <Tooltip
                id="productImageHoverTooltip"
                effect="solid"
                title={buildTooltip(imgSrc, ReactHTMLParser(title), subtitle)}
            >
                <div data-testid="product-img">
                    <ResponsiveImageOrSvg dynamicIcon={dynamicIcon} responsiveImageClassName={itemImg} />
                </div>
            </Tooltip>
        )
            : (
                <ResponsiveImageOrSvg dynamicIcon={dynamicIcon} responsiveImageClassName={itemImg} />
            ));

        const optionText = (
            <>
                <span className={listItemName}>
                    <span className={`${listPickerOption?.subtitle ? bold : ''}`}>{ReactHTMLParser(listPickerOption?.title)}</span>
                    <span className={listItemSubtitle}>{listPickerOption?.subtitle}</span>
                    <span />
                </span>
                <span className={checkIcon} />
            </>
        );
        const seed = useUIDSeed();

        return listPickerOption && (
            <button
                type="button"
                key={seed(listPickerOption)}
                className={`${listGroupItem} ${listGroupItemAction} ${flexColum} ${alignItemsStart} ${listItemLink}`}
                onClick={(e) => {
                    e.preventDefault();
                    const selectedItem = {
                        selectedIdentifier: listitem.identifier,
                        title: listPickerOption.title,
                        subtitle: listPickerOption.subtitle,
                        selectedImage: dynamicIcon,
                        messageType: 'text',
                    };
                    onSubmitMessage(selectedItem, messageObj);
                }}
                data-testid="picker-option"
            >
                <div className={listItem} id={`listitem${index}`}>
                    {
                        index !== 0
                            ? (
                                preview(listitem.data, listPickerOption.title, listPickerOption.subtitle)
                            )
                            : (
                                <ResponsiveImageOrSvg dynamicIcon={dynamicIcon} responsiveImageClassName={itemImg} />
                            )
                    }
                    {
                        interactiveData?.hover === 'Y' && index !== 0 ? (
                            <Tooltip
                                backgroundColor="white"
                                borderColor="#DDDDDD"
                                effect="solid"
                                title={interactiveData?.receivedMessage?.title}
                            >
                                {optionText}
                            </Tooltip>
                        ) : optionText
                    }
                </div>
            </button>
        );
    });

    return (
        <div className={matches ? mediaDialog : dialog}>
            <div className={dialogHeader}>
                <h5 className={dialogTitle}>{interactiveData?.receivedMessage?.title}</h5>
                <button type="button" onClick={closeDialog} className={close} data-testid="close-dialog-btn">
                    <span data-testid="close-btn">×</span>
                </button>
            </div>
            <div className={dialogBody}>
                <div className={`${listPicker} ${my2}`} id="listpickerdiv">
                    <div><strong>{interactiveData?.receivedMessage?.subtitle}</strong></div>
                    <div className={listGroup}>
                        {
                            listOptions
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

ChatDialog.propTypes = {
    interactiveData: object.isRequired,
    messageObj: object.isRequired,
    // functions
    getSVGByKey: func.isRequired,
    closeDialog: func.isRequired,
    onSubmitMessage: func.isRequired,
};

export default ChatDialog;
